import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow, CSelect } from "@coreui/react";
import { useRemissionNoteFormContext } from "../context/RemissionNoteFormContext";
import {
  TRANSPORT_MODE_CHOICES,
  TRANSPORT_RESPONSIBLE_CHOICES,
  TRANSPORT_TYPE_CHOICES,
} from "../../../models/transport";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const RemissionNoteFormTransportSection: React.FC = () => {
  const {
    remissionNoteRef,
    errors,
    onTransportEstimatedStartDate,
    onTransportEstimatedEndDate,
    onTransportTypeCodeChange,
    onTransportModeCodeChange,
    onTransportResponsibleCodeChange,
  } = useRemissionNoteFormContext();

  return (
    <>
      <SectionDivider icon="fa-truck" label="Datos de Transporte" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Fecha Inicio:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="date"
              placeholder="Fecha de Inicio del Transporte"
              onChange={onTransportEstimatedStartDate}
              defaultValue={
                remissionNoteRef.current !== null
                  ? remissionNoteRef.current.transportEstimatedStartDate
                  : ""
              }
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportEstimatedStartDate", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Fecha Fin:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="date"
              placeholder="Fecha de Fin del Transporte"
              onChange={onTransportEstimatedEndDate}
              defaultValue={
                remissionNoteRef.current !== null
                  ? remissionNoteRef.current.transportEstimatedEndDate
                  : ""
              }
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportEstimatedEndDate", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Tipo de Transporte:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportTypeCode
                  : undefined
              }
              onChange={onTransportTypeCodeChange}
            >
              <option value={""}>-----</option>
              {Array.from(TRANSPORT_TYPE_CHOICES.entries()).map((entry) => {
                return (
                  <option key={entry[0]} value={entry[0]}>
                    {entry[1]}
                  </option>
                );
              })}
            </CSelect>
            <FieldErrors
              errors={getFieldErrors("transportTypeCode", errors) as string[]}
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Modalidad:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportModeCode
                  : undefined
              }
              onChange={onTransportModeCodeChange}
            >
              <option value={""}>-----</option>
              {Array.from(TRANSPORT_MODE_CHOICES.entries()).map((entry) => {
                return (
                  <option key={entry[0]} value={entry[0]}>
                    {entry[1]}
                  </option>
                );
              })}
            </CSelect>
            <FieldErrors
              errors={getFieldErrors("transportModeCode", errors) as string[]}
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Responsable:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportResponsibleCode
                  : undefined
              }
              onChange={onTransportResponsibleCodeChange}
            >
              <option value={""}>-----</option>
              {Array.from(TRANSPORT_RESPONSIBLE_CHOICES.entries()).map(
                (entry) => {
                  return (
                    <option key={entry[0]} value={entry[0]}>
                      {entry[1]}
                    </option>
                  );
                }
              )}
            </CSelect>
            <FieldErrors
              errors={
                getFieldErrors("transportResponsibleCode", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};
